import { ActionTracking } from './structs/structs'

export class APIError extends Error {
  constructor (message, response) {
    super(message)
    this.name = this.constructor.name
    this.response = response
  }
}

export class DailyTrackableConstructor {
  get dayDuration () { return 86400000 }

  constructor ({ actionId = null, coachingDayOneTimestamp = null, startDay = null, endDay = null } = {}) {
    this.actionId = actionId
    this.coachingDayOneTimestamp = coachingDayOneTimestamp
    this.startDay = startDay
    this.endDay = endDay

    Object.defineProperties(
      this,
      {
        'duration': {
          configurable: false,
          enumerable: true,
          get () { return this.endDay - (this.startDay - 1) }
        },
        'dailyTimestamps': {
          configurable: false,
          enumerable: false,
          get () {
            return (
              new Array(this.duration)
                .fill()
                .map((_, day) => this.coachingDayOneTimestamp + ((this.startDay - 1 + day) * this.dayDuration))
            )
          }
        },
        'events': {
          configurable: false,
          enumerable: true,
          get () {
            return (
              this.dailyTimestamps.map(
                timestamp => (
                  new ActionTracking(
                    {
                      type: 'action',
                      startTimestamp: timestamp,
                      endTimestamp: timestamp,
                      data: {
                        actionId: this.actionId,
                        trackingType: 'daily',
                        completionStatus: null
                      }
                    }
                  )
                )
              )
            )
          }
        }
      }
    )
  }
}

export class OneTimeTrackableConstructor {
  get dayDuration () { return 86400000 }

  constructor ({ actionId = null, coachingDayOneTimestamp = null, startDay = null, endDay = null } = {}) {
    this.actionId = actionId
    this.coachingDayOneTimestamp = coachingDayOneTimestamp
    this.startDay = startDay
    this.endDay = endDay

    Object.defineProperties(
      this,
      {
        'startTimestamp': {
          configurable: false,
          enumerable: false,
          get () {
            return this.coachingDayOneTimestamp + ((this.startDay - 1) * this.dayDuration)
          }
        },
        'endTimestamp': {
          configurable: false,
          enumerable: false,
          get () {
            return this.coachingDayOneTimestamp + ((this.endDay - 1) * this.dayDuration)
          }
        },
        'event': {
          configurable: false,
          enumerable: true,
          get () {
            return (
              new ActionTracking(
                {
                  type: 'action',
                  startTimestamp: this.startTimestamp,
                  endTimestamp: this.endTimestamp,
                  data: {
                    actionId: this.actionId,
                    trackingType: 'once',
                    completionStatus: null
                  }
                }
              )
            )
          }
        }
      }
    )
  }
}

export class NonTrackableConstructor {
  get dayDuration () { return 86400000 }

  constructor ({ actionId = null, coachingDayOneTimestamp = null, startDay = null, endDay = null } = {}) {
    this.actionId = actionId
    this.coachingDayOneTimestamp = coachingDayOneTimestamp
    this.startDay = startDay
    this.endDay = endDay

    Object.defineProperties(
      this,
      {
        'startTimestamp': {
          configurable: false,
          enumerable: false,
          get () {
            return this.coachingDayOneTimestamp + ((this.startDay - 1) * this.dayDuration)
          }
        },
        'endTimestamp': {
          configurable: false,
          enumerable: false,
          get () {
            return this.coachingDayOneTimestamp + ((this.endDay - 1) * this.dayDuration)
          }
        },
        'event': {
          configurable: false,
          enumerable: true,
          get () {
            return (
              new ActionTracking(
                {
                  type: 'action',
                  startTimestamp: this.startTimestamp,
                  endTimestamp: this.endTimestamp,
                  data: {
                    actionId: this.actionId,
                    trackingType: 'none',
                    completionStatus: false
                  }
                }
              )
            )
          }
        }
      }
    )
  }
}
